import { render, staticRenderFns } from "./AccuracyCourseRow.vue?vue&type=template&id=675a2840&scoped=true&"
import script from "./AccuracyCourseRow.vue?vue&type=script&lang=js&"
export * from "./AccuracyCourseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675a2840",
  null
  
)

export default component.exports